import { gql } from '@apollo/client';
import { coverFragment } from './MediaQueries';

export const submissionFragment = gql`
  fragment Submission on Submission {
    __typename
    id
    isCustomized
    isOverscale
    overscaleNote
    role {
      __typename
      id
      projectId
      name
    }
    submissionStatus {
      __typename
      id
      code
    }
    cover {
      __typename
      ...CoverMedia
    }
    note
  }
  ${coverFragment}
`;
